document.addEventListener('DOMContentLoaded', function () {
    const debugEnabled = window.survey_popup_debug === true || window.survey_popup_debug === 'true';

    const debug = (message, data = null) => {
        if (debugEnabled) {
            if (data) {
                console.log(message, data);
            } else {
                console.log(message);
            }
        }
    };

    debug('🔥 Survey Popup Debug - Script Starting');

    // Scope all lookups to the survey wrapper so the newsletter popup (same classes) is never affected
    const popupRoot = document.getElementById('survey-popup');
    const $scoped = (selector) => jQuery(popupRoot).find(selector);
    const surveyPopup = popupRoot ? popupRoot.querySelector('.ticket-popup') : null;
    const surveyBackdrop = popupRoot ? popupRoot.querySelector('.ticket-popup__lightbox') : null;
    const closeButton = popupRoot ? popupRoot.querySelector('.ticket-popup__close') : null;
    const surveyButton = popupRoot ? popupRoot.querySelector('.ticket-popup__button') : null;

    // Keys are separate from the newsletter popup so dismissing one never affects the other
    const STORAGE_KEY_CLOSED_SESSION = 'survey_popup_closed_session';
    const LEGACY_KEY_CLOSED = 'survey_popup_closed';
    const STORAGE_KEY_CLICKED = 'survey_popup_clicked';
    const PAGE_COUNT_KEY = 'survey_popup_page_visit_count';
    const SESSION_COUNT_KEY = 'survey_popup_session_count';
    const LAST_ACTIVITY_KEY = 'survey_popup_last_activity';

    // A new session starts after 30 minutes with no page views (same idea as Google Analytics)
    const SESSION_TIMEOUT_MS = 30 * 60 * 1000;
    const now = Date.now();
    const lastActivity = parseInt(localStorage.getItem(LAST_ACTIVITY_KEY), 10);
    let sessionCount = parseInt(localStorage.getItem(SESSION_COUNT_KEY), 10) || 0;
    if (!sessionCount || isNaN(lastActivity) || now - lastActivity > SESSION_TIMEOUT_MS) {
        sessionCount++;
        localStorage.setItem(SESSION_COUNT_KEY, sessionCount);
    }
    localStorage.setItem(LAST_ACTIVITY_KEY, now);

    // Increment page visit count
    let pageVisitCount = parseInt(localStorage.getItem(PAGE_COUNT_KEY)) || 0;
    pageVisitCount++;
    localStorage.setItem(PAGE_COUNT_KEY, pageVisitCount);

    const visitedPages = parseInt(window.survey_popup_trigger, 10) || 1;
    const isEnabled = window.survey_popup_enabled === true || window.survey_popup_enabled === 'true';
    const isPageExcluded = Array.isArray(window.survey_popup_excluded_posts) &&
                           window.survey_popup_excluded_posts.includes(window.current_post_id);
    const newsletterShowing = window.newsletter_popup_will_show === true;

    // Dismissal stores the session number; the popup comes back once enough new sessions have started.
    // The old permanent "closed" flag is dropped, so visitors who dismissed it before see it again.
    localStorage.removeItem(LEGACY_KEY_CLOSED);
    const dismissSessions = parseInt(window.survey_popup_dismiss_sessions, 10) || 3;
    const dismissedSession = parseInt(localStorage.getItem(STORAGE_KEY_CLOSED_SESSION), 10);
    const dismissalExpired = isNaN(dismissedSession) || (sessionCount - dismissedSession) >= dismissSessions;

    const conditions = {
        'enabled': isEnabled,
        'pageCountMet': pageVisitCount >= visitedPages,
        'dismissalExpired': dismissalExpired,
        'notClicked': !localStorage.getItem(STORAGE_KEY_CLICKED),
        'popupExists': !!surveyPopup,
        'pageNotExcluded': !isPageExcluded,
        // Wait for a later page view rather than stacking on top of the newsletter popup
        'newsletterNotShowing': !newsletterShowing
    };

    debug('📊 Configuration Values:', {
        'pageVisitCount': pageVisitCount,
        'visitedPages': visitedPages,
        'sessionCount': sessionCount,
        'dismissSessions': dismissSessions,
        'dismissedSession': isNaN(dismissedSession) ? null : dismissedSession,
        'excludedPosts': window.survey_popup_excluded_posts,
        'currentPostId': window.current_post_id
    });
    debug('✅ Condition Checks:', conditions);

    const shouldShowPopup = Object.values(conditions).every(Boolean);

    const hidePopup = (speed) => {
        if (window.matchMedia("(max-width: 768px)").matches) {
            $scoped(".ticket-popup, .ticket-popup__lightbox").fadeOut(speed);
        } else {
            $scoped(".ticket-popup").fadeOut(speed);
        }
    };

    if (shouldShowPopup) {
        debug('🚀 Showing survey popup in 1 second...');
        setTimeout(() => {
            if (window.matchMedia("(max-width: 768px)").matches) {
                // On mobile, show popup with lightbox
                $scoped(".ticket-popup, .ticket-popup__lightbox").fadeIn(600);
            } else {
                // On desktop, show the popup only
                $scoped(".ticket-popup").fadeIn(600);
            }
        }, 1000);
    } else {
        debug('❌ Survey popup will NOT show. Reasons:', Object.entries(conditions).filter(([key, value]) => !value));
    }

    // Handle popup close button click
    if (closeButton) {
        closeButton.addEventListener('click', () => {
            debug('🚪 Survey popup close button clicked');
            hidePopup();
            localStorage.setItem(STORAGE_KEY_CLOSED_SESSION, sessionCount);
        });
    }

    // Handle backdrop click to close popup (counts as dismissal)
    if (surveyBackdrop) {
        surveyBackdrop.addEventListener('click', () => {
            debug('🌫️ Backdrop clicked - dismissing survey popup');
            $scoped(".ticket-popup, .ticket-popup__lightbox").fadeOut();
            localStorage.setItem(STORAGE_KEY_CLOSED_SESSION, sessionCount);
        });
    }

    // Clicking through to the survey counts as completion, so don't show it again
    if (surveyButton) {
        surveyButton.addEventListener('click', () => {
            debug('📝 Survey link clicked');
            localStorage.setItem(STORAGE_KEY_CLICKED, 'true');
            $scoped(".ticket-popup, .ticket-popup__lightbox").fadeOut();
        });
    }
});
